// extracted by mini-css-extract-plugin
export default {"card":"Avatar_card__IASFp","image":"Avatar_image__EGwT7","title":"Avatar_title__H7hV-"};